export default __webpack_public_path__ + "static/seo-img-157088747e983ee2448b89c5a2c184c4.jpg";